import OrderDTO from "@/dto/order/OrderDTO";
import React from "react";
import { ShipValidationRule, ShipValidationRuleKey } from "../type";
import { buildValidationSuccessfulResult } from "../util";
import { Modal } from "antd";
import {
    isAnyOrderWithAliCanNotShipTag,
    isAnyOrderWithCanNotShipTag,
    isAnyOrderWithTbCanNotShipTag,
} from "@/utils/OrderTagUtils";

function aliCanNotShipOrderConfirm() {
    return new Promise<boolean>((resolve, reject) => {
        Modal.confirm({
            title: "所选订单包含阿里不能发货订单",
            onOk() {
                resolve(true);
            },
            onCancel() {
                reject(new Error("用户取消操作"));
            },
            focusable: { focusTriggerAfterClose: true },
            content: <span className="error">请先查看收货人地址下方的不可发货原因并确认无误之后再操作</span>,
        });
    });
}

function tbCanNotShipOrderConfirm() {
    return new Promise<boolean>((resolve, reject) => {
        Modal.confirm({
            title: "所选订单包含淘宝不能发货订单",
            onOk() {
                resolve(true);
            },
            onCancel() {
                reject(new Error("用户取消操作"));
            },
            focusable: { focusTriggerAfterClose: true },
            content: <span className="error">请先确认无误之后再操作</span>,
        });
    });
}

function canNotShipOrderConfirm() {
    return new Promise<boolean>((resolve, reject) => {
        Modal.confirm({
            title: "所选订单包含不可发货订单",
            onOk() {
                resolve(true);
            },
            onCancel() {
                reject(new Error("用户取消操作"));
            },
            focusable: { focusTriggerAfterClose: true },
            content: <span className="error">请先查看收货人地址下方的不可发货原因并确认无误之后再操作</span>,
        });
    });
}

export default async function validateCannotShipTag(orders: OrderDTO[], rule: ShipValidationRule) {
    if (!rule[ShipValidationRuleKey.checkCannotShipTag]) return buildValidationSuccessfulResult(orders);

    if (isAnyOrderWithAliCanNotShipTag(orders)) {
        await aliCanNotShipOrderConfirm();
    }

    if (isAnyOrderWithTbCanNotShipTag(orders)) {
        await tbCanNotShipOrderConfirm();
    }

    if (isAnyOrderWithCanNotShipTag(orders)) {
        await canNotShipOrderConfirm();
    }

    return buildValidationSuccessfulResult(orders);
}
